import { forwardRef, useCallback } from 'react';
import classNames from 'classnames';

import noop from '../../../../utils/noop';

import IRadio from './types';
import useStyles from './styles';

export function Radio({
  className,
  children,
  name,
  mRef,
  disabled,
  selected,
  value,
  onSelect,
}: IRadio) {
  const styles = useStyles();

  const toggleIsActive = useCallback(() => {
    onSelect && onSelect(value);
  }, [onSelect, value]);

  return (
    <label
      id={name}
      className={classNames(styles.root, { active: selected, disabled }, { selected }, className)}
      tabIndex={0}
      onClick={toggleIsActive}
      role="button"
    >
      <input
        className={styles.control}
        name={name}
        onChange={noop}
        ref={mRef}
        disabled={disabled}
        checked={selected}
        value={value}
        type="radio"
      />

      <span className={classNames(styles.icon, { active: selected })}>
        {selected && <span className={classNames('check')}></span>}
      </span>

      <span className={styles.label}>{children}</span>
    </label>
  );
}

const RadioWithForwardedRef = forwardRef<HTMLInputElement, IRadio>((props, ref) => (
  <Radio {...props} mRef={ref} />
));
RadioWithForwardedRef.displayName = 'Radio';

export default RadioWithForwardedRef;
